import script from "./SapReportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SapReportView.vue?vue&type=script&setup=true&lang=ts"

import "./SapReportView.vue?vue&type=style&index=0&id=1dd0c799&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd0c799"]])

export default __exports__